<template>
  <div class="flex flex-wrap">
    <div class="w-full">
      <announcement-component />
    </div>
    <div class="w-full pb-10 ">
      <h4 class="font-bold">
        Tasks:
      </h4>
      <p class="pb-3">
        You'll see up to six tasks you are assigned to or that you're the reviewer of here, ordered by the closest due date.
      </p><p />
      <div class="flex flex-wrap -mx-5">
        <div class="w-full md:w-1/2 px-5 mb-5 md:mb-0">
          <div class="bg-white px-10 py-5 rounded-lg md:px-10 shadow">
            <div class="flex pb-3">
              <d-icon class="text-secondary-500" size="lg" icon="list" />
              <p class="px-3 font-bold">
                My Assigned Tasks
              </p>
            </div>
            <div>
              <div v-if="todosAssignedToMe.length > 0">
                <hr>
                <div v-for="todo in todosAssignedToMe" :key="todo.id" class="pb-2 cursor-pointer" @click="gotoTodo(todo)">
                  <div class="flex items-center">
                    <div class="flex-grow">
                      <p class="font-bold">
                        {{ todo.name }}
                      </p>
                      <p>
                        {{ todo.assignmentName }}
                      </p>
                      <p>
                        Due: {{ todo.dueDate | formatShortDate }}
                      </p>
                      <p>
                        Reviewer: {{ todo.reviewerFullName }}
                      </p>
                      <div v-if="!todo.submitted">
                        <span v-if="todo.overdue" class="text-error">
                          Overdue!
                        </span>
                        <span v-else-if="todo.dueSoon" class="text-error">
                          Due soon!
                        </span>
                      </div>
                    </div>
                    <div class="flex-shrink">
                      <d-icon icon="angle-right" class="text-black" size="lg" />
                    </div>
                  </div>
                  <hr>
                </div>
              </div>
              <div v-else>
                No tasks currently assigned
              </div>
            </div>
          </div>
        </div>

        <div class="w-full md:w-1/2 px-5">
          <div class="bg-white px-10 py-5 rounded-lg md:px-10 shadow">
            <div class="flex pb-3">
              <d-icon class="text-secondary-500" size="lg" icon="list" />
              <p class="px-3 font-bold">
                Tasks ready for My Review
              </p>
            </div>
            <div>
              <div v-if="todosForMyReview.length > 0">
                <hr>
                <div v-for="todo in todosForMyReview" :key="todo.id" class="pb-2 cursor-pointer" @click="gotoTodo(todo)">
                  <div class="flex items-center">
                    <div class="flex-grow">
                      <p class="font-bold">
                        {{ todo.name }}
                      </p>
                      <p>
                        {{ todo.assignmentName }}
                      </p>
                      <p>
                        Due: {{ todo.dueDate | formatShortDate }}
                      </p>
                      <p>
                        Submitter: {{ todo.assigneeFullName }}
                      </p>
                    </div>
                    <div class="flex-shrink">
                      <d-icon icon="angle-right" class="text-black" size="lg" />
                    </div>
                  </div>
                  <hr>
                </div>
              </div>
              <div v-else>
                No tasks currently ready for review
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <a href="/assignments">View all assignments ></a>
      </div>
    </div>

    <div class="w-full">
      <h4 class="font-bold">
        Upcoming Events:
      </h4>
      <calendar-component />
    </div>
  </div>
</template>
<script>

  import axios from 'axios';
  import AnnouncementComponent from './components/AnnouncementComponent.vue';
  import CalendarComponent from './components/CalendarComponent.vue';

  export default {
    parent: true,
    components: {
      AnnouncementComponent,
      CalendarComponent,
    },

    data: () => ({
      todosAssignedToMe: [],
      todosForMyReview: [],
    }),

    mounted() {
      this.getTodos();
    },
    methods: {
      async getTodos() {
        const { data } = await axios.get('/api/gateway/todos-assigned/');
        this.todosAssignedToMe = data;

        const { data: reviewTodos } = await axios.get('/api/gateway/todos-for-review/');
        this.todosForMyReview = reviewTodos;
      },
      gotoTodo(todo) {
        window.location = `/assignments/todo/${todo.id}`;
      },
    },
  };
</script>